import { ref } from 'vue'

/**
 * The hard stop shown when automatic recovery from a stale route chunk has been exhausted —
 * see utils/staleAssetRecovery. Not dismissible: the destination route cannot load, so
 * carrying on in the app is not an option worth offering.
 *
 * Module-scope state so the overlay is an app-level singleton, mirroring useConfirm.
 */
const reloadRequired = ref(false)

export function useAppUpdate() {
	const requireReload = () => {
		reloadRequired.value = true
	}

	const reload = () => {
		window.location.reload()
	}

	return {
		reloadRequired,
		requireReload,
		reload,
	}
}
